import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
export function MainContent() {
  const categories = [{
    icon: '🥖',
    name: 'Panes y panificados'
  }, {
    icon: '🥟',
    name: 'Empanadas'
  }, {
    icon: '🍕',
    name: 'Pizzas'
  }, {
    icon: '🍝',
    name: 'Pastas'
  }, {
    icon: '🍪',
    name: 'Snacks'
  }, {
    icon: '🍰',
    name: 'Postres'
  }, {
    icon: '🥤',
    name: 'Bebidas'
  }, {
    icon: '🥗',
    name: 'Comidas principales'
  }, {
    icon: '🍳',
    name: 'Desayunos'
  }, {
    icon: '☕',
    name: 'Opciones para acompañar el mate'
  }];
  return <section className="py-20 md:py-32 px-6 bg-gray-900 text-white" data-id="element-92">
      <div className="max-w-5xl mx-auto" data-id="element-93">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-94">
          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-6" data-id="element-95">
            Todo lo que vas a recibir
          </h2>
          <p className="text-xl text-gray-300 max-w-2xl mx-auto" data-id="element-96">
            Una colección completa para ayudarte a recuperar el placer de comer.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16" data-id="element-97">
          {categories.map((cat, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.05
        }} className="bg-gray-800 p-6 rounded-2xl flex items-center space-x-4 border border-gray-700 hover:border-primary/50 transition-colors" data-id="element-98">
              <span className="text-3xl" data-id="element-99">{cat.icon}</span>
              <span className="text-lg font-medium" data-id="element-100">{cat.name}</span>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center bg-primary/20 border border-primary/30 p-8 rounded-3xl" data-id="element-101">
          <p className="text-2xl md:text-3xl font-serif font-bold text-white flex items-center justify-center flex-wrap gap-3" data-id="element-102">
            <Check className="w-8 h-8 text-primary-light" data-id="element-103" />
            Más de 100 recetas explicadas paso a paso.
          </p>
        </motion.div>
      </div>
    </section>;
}